import "react";
import { jsx as o, jsxs as t } from "react/jsx-runtime";
var i = (r) => /* @__PURE__ */ t("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: [
    /* @__PURE__ */ o("path", {
      d: "M12 19V12",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M9.83301 14L12 11.833L14.167 14",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */ o("path", {
      d: "M16 19H18.56C20.488 19 22.06 17.428 22.06 15.5C22.06 13.572 20.488 12 18.56 12H18.125V11C18.125 7.69 15.435 5 12.125 5C9.148 5 6.68 7.178 6.212 10.023C3.835 10.144 1.94 12.093 1.94 14.5C1.94 16.985 3.955 19 6.44 19H8",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  ]
});
export {
  i as default
};

//# sourceMappingURL=Export.js.map